import { useState, useRef } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

export const VariableHelpTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div
          className="inline-flex cursor-help items-center gap-1 text-blue-600 hover:text-blue-700"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        >
          <Info size={14} />
          <p className="text-xs font-medium">
            Puedes usar variables.
          </p>
        </div>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        className="max-w-[300px] border-gray-700 bg-gray-800 text-white"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="flex flex-col gap-2">
          <p className="text-sm font-bold">
            Variables disponibles:
          </p>
          <div>
            <p className="mb-1 text-xs font-bold text-blue-300">
              {"{transferReason}"}
            </p>
            <p className="text-xs">
              Razón por la cual el lead fue transferido a un agente humano. Se reemplazará
              automáticamente con el valor del lead.
            </p>
          </div>
          <div>
            <p className="mb-1 text-xs font-bold text-blue-300">
              {"{discardedReason}"}
            </p>
            <p className="text-xs">
              Razón por la cual el lead fue descartado. Se reemplazará automáticamente con el
              valor del lead.
            </p>
          </div>
          <div>
            <p className="mb-1 text-xs font-bold text-blue-300">
              {"{leadUrl}"}
            </p>
            <p className="text-xs">
              Enlace a la conversación en el dashboard. Se reemplazará automáticamente con el
              valor del lead.
            </p>
          </div>
          <div>
            <p className="mb-1 text-xs font-bold text-blue-300">
              {"{conversationContent}"}
            </p>
            <p className="text-xs">
              Contenido de la conversación. Se reemplazará automáticamente con la conversación
              entre el cliente y el agente en formato texto.
            </p>
          </div>
          <p className="mb-1 text-xs font-bold text-blue-300">
            Ejemplos:
          </p>
          <p className="text-xs">
            {
              "Razón de transferencia: {transferReason}, enlace a la conversación: {leadUrl}, contenido de la conversación: {conversationContent}"
            }
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
